import React from 'react';
import { notifySalesforceConnection } from '../connectionChannel';

const ERROR_STATES = {
    salesforce: {
        title: 'Salesforce connection failed',
        description: 'We were unable to connect to Salesforce. Please try again later.',
    },
    auth: {
        title: 'Salesforce connection failed - Authentication error',
        description: 'Your session has expired or is invalid.',
    },
    network: {
        title: 'Salesforce connection failed - Network issue',
        description: 'A network error occurred while processing your request.',
    },
};

export const SalesforceFailureResult = () => {
    const params = new URLSearchParams(window.location.search);
    const errorType = params.get('errorType') || 'salesforce';
    const error = ERROR_STATES[errorType] || ERROR_STATES.salesforce;

    React.useEffect(() => {
        notifySalesforceConnection(false);
    }, []);

    return (
        <div style={{ padding: '100px 50%' }}>
            <div style={{ textAlign: 'center', width: '350px' }}>
                <div style={{ marginTop: '50px' }}>
                    <h4>{error.title}</h4>
                    <p style={{ marginTop: '10px', color: '#666' }}>{error.description}</p>
                    <button onClick={() => window.close()} className="btn btn-primary" style={{ marginTop: '30px' }}>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SalesforceFailureResult;
